import { NestedRoutes } from "../../app/routes.types";
import { AdminLayout } from "./layout";

import { MemberRoutes } from "./Members/routes";
import { TeamsRoutes } from "./Teams/routes";
import { RolesRoutes } from "./Roles/routes";
import { OfficesRoutes } from "./Offices/routes";
import { CompaniesRoutes } from "./Companies/routes";

export const adminRoutes: NestedRoutes = {
  path: "admin",
  name: "Admin",
  layout: AdminLayout,
  defaultPath: "members",
  children: [
    MemberRoutes,
    // { icon: CandidatesIcon, name: "Candidates" },
    TeamsRoutes,
    RolesRoutes,
    // { icon: HrFlowIcon, name: "Hr Flow" },
    // { icon: FeedbackIcon, name: "Feedback" },
    // { icon: RewardsIcon, name: "Rewards" },
    // { icon: TrainingIcon, name: "Training" },
    OfficesRoutes,
    CompaniesRoutes,
    // { icon: CommunicationIcon, name: "Communication" },
    // { icon: CalendarIcon, name: "Calendar" },
    // { icon: MediaIcon, name: "Media" },
  ],
};
